// extracted by css-extract-rspack-plugin
var _1 = "filter-dd7zyB";
var _2 = "query-w_wzZK";
var _3 = "table-WRGVau";
export { _1 as "filter", _2 as "query", _3 as "table" }
